<form #form="ngForm" novalidate *ngIf="entity">
    <div class="row">
        <div class="form-group col-12">
            <label for="enderecoCidade_{{tipoEndereco}}" class="col-form-label">Cidade</label>
            <sgt-typeahead-cidade [(ngModel)]="entity.cidade" name="enderecoCidade_{{tipoEndereco}}" id="enderecoCidade_{{tipoEndereco}}"
                #enderecoCidade="ngModel" [ngControl]="enderecoCidade" [required]="cidadeRequired"
                (entitySelected)="onSelectCidade($event)"
                (clearEntity)="clearCidade()"
                [disabled]="!canEdit" [readonly]="!canEdit">
            </sgt-typeahead-cidade>                    
            <sgt-form-control-error
                *ngIf="enderecoCidade.errors && enderecoCidade.errors.required && enderecoCidade.dirty"
                msgError="A cidade é obrigatória">
            </sgt-form-control-error>
        </div>
    </div>

    <div class="row" *ngIf="isShowSubRegiaoEBairro()">
        <div class="form-group col-12 col-md-6">
            <label for="subRegiao_{{tipoEndereco}}" class="col-form-label">Sub-região</label>
            <select class="form-control" name="subRegiao_{{tipoEndereco}}" id="subRegiao_{{tipoEndereco}}" 
                [ngModel]="entity.idCidadeSubRegiao || ''" (ngModelChange)="onChangeSubRegiao($event ? $event : null)"
                #subRegiao="ngModel" required="required"
                [disabled]="!canEdit">
                <option value="">Selecione a sub-região da cidade...</option>
                <option *ngFor="let subRegiao of subRegioes" [ngValue]="subRegiao.id">{{subRegiao.nome}}</option>
            </select>                            
            <sgt-form-control-error
                *ngIf="subRegiao.errors && subRegiao.errors.required && subRegiao.dirty"
                msgError="A sub-região da cidade é obrigatória">
            </sgt-form-control-error>                               
        </div>
        <div class="form-group col-12 col-md-6">
            <label for="subRegiaoBairro_{{tipoEndereco}}" class="col-form-label">Bairro da Sub-região</label>
            <select class="form-control" name="subRegiaoBairro_{{tipoEndereco}}" id="subRegiaoBairro_{{tipoEndereco}}" 
                [ngModel]="entity.idCidadeSubRegiaoBairro || ''" (ngModelChange)="entity.idCidadeSubRegiaoBairro = $event ? $event : null"
                #subRegiaoBairro="ngModel" required="required"
                [disabled]="!canEdit">
                <option value="">Selecione o bairro da sub-região...</option>
                <option *ngFor="let bairro of bairros" [ngValue]="bairro.id">{{bairro.nome}}</option>
            </select>                            
            <sgt-form-control-error
                *ngIf="subRegiaoBairro.errors && subRegiaoBairro.errors.required && subRegiaoBairro.dirty"
                msgError="O bairro da sub-região é obrigatório">
            </sgt-form-control-error>                               
        </div>                
    </div>

    <div class="row" >
        <div class="form-group col-12">
            <label for="enderecoPais_{{tipoEndereco}}" class="col-form-label">País</label>
            <sgt-pais-typeahead [(ngModel)]="entity.pais" name="enderecoPais_{{tipoEndereco}}" id="enderecoPais_{{tipoEndereco}}"
                #enderecoPais="ngModel" [ngControl]="enderecoPais" [required]="paisRequired"
                (typeaheadChange)="onChangePais($event)"
                [disabled]="!canEdit" [readonly]="!canEdit">
            </sgt-pais-typeahead>                    
            <sgt-form-control-error
                *ngIf="enderecoPais.errors && enderecoPais.errors.required && enderecoPais.dirty"
                msgError="O país é obrigatório">
            </sgt-form-control-error>
        </div>
    </div>    
</form>